import styles from "./ContactView.module.css";
import PropTypes from "prop-types";

/**
 * Displays a single contact record.
 */
export function ContactView({ contact }) {
  return (
    <div className={styles.container}>
      <span className={styles.name}>{contact.name}</span>
      {contact.iboNumber && (
        <span className={styles.phone}>IBO# {contact.iboNumber}</span>
      )}
      {contact.pinLevel && (
        <span className={styles.email}>{contact.pinLevel}</span>
      )}
      <span className={styles.phone}>{contact.phone}</span>
      {contact.email && <span className={styles.email}>{contact.email}</span>}
    </div>
  );
}

ContactView.propTypes = {
  contact: PropTypes.shape({
    name: PropTypes.string.isRequired,
    phone: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
};
